
import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
    state('fadeIn', style({ opacity: 1 })),
    transition('void => *', [
        style({ opacity: 0 }),
        animate(300)
    ]),
    transition('* => void', [
        animate(300, style({ opacity: 0 }))
    ])
]);
